import {
    browserTracingIntegration,
    captureException,
    init,
    setContext,
    setTag,
} from '@sentry/react';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
const isSentryEnabled = Boolean(process.variable.SENTRY_CONTEXT);
export default class SentryService {
    static initSentry() {
        if (!isSentryEnabled) {
            return;
        }

        init({
            dsn: 'https://32fb26b650c84652987395b2b0b2a01a@sentry.aqua.network/105',
            integrations: [browserTracingIntegration()],
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            environment: process.variable.SENTRY_CONTEXT,
            tracesSampleRate: 0.1,
        });
    }

    static captureException({ error, prefix, extra }) {
        error = typeof error === 'string' ? new Error(error) : error;

        if (prefix) {
            error = new Error(`${prefix}: ${error.message}`, {
                cause: error,
            });
        }

        if (isSentryEnabled) {
            captureException(error, { extra });
        } else {
            console.warn('Error boundary exception: ', error, extra);
        }
    }

    static setSentryContext({ publicKey, authType }) {
        if (!isSentryEnabled) {
            return;
        }

        const userKey = publicKey || 'No public key';
        const loginType = authType || 'No auth type';

        setTag('user.publicKey', userKey);
        setTag('user.authType', loginType);
        setContext('additional user info', {
            publicKey: userKey,
            authType: loginType,
        });
    }
}
